// extracted by mini-css-extract-plugin
export default {"breaker":"Continents_breaker__JBuun"};